import React, { Fragment } from 'react';
import { Card, Row, Col } from 'antd';
import { usePermission } from '@contexts/Auth/UsePermission';
import Page403 from '@page/Common/403/403';
import StatCards from './components/StatCards';
import styled from 'styled-components';
import List from './components/List';
import ContainerBody from '@components/ContainerBody';
import Breadcrumb from '@components/Breadcrumb';

const Replacements = () => {
  const { replacement } = usePermission();

  // Nếu không có quyền view, hiển thị trang 403
  if (!replacement.view) {
    return (
      <ContainerBody>
        <Page403 />
      </ContainerBody>
    );
  }

  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/dashboard'}
          routeSegments={[{ name: 'Quản lý thay thế lắp mới', path: '/replacements' }]}
        />
      </div>
      <Row>
        <Col span={24}>
          <List />
        </Col>
      </Row>
    </ContainerBody>
  );
};

export default Replacements;
